export interface CompanyFormData {
  id: string;
  name: string;
  link: string;
  phone: string;
  billingAddress: {
    billingStreet: string;
    billingCity: string;
    billingCountry: string;
    billingPostalCode: string;
    billingState: string;
  };
}
